export const shipmentStatusTabs = [
  {
    statusId: '1',
    statusText: 'Channel Order',
    statusCode: 'pending',
    isActive: false,
  },
  {
    statusId: '2',
    statusText: 'Ready For Pickup',
    statusCode: 'ready_for_pickup,out_for_pickup',
    isActive: false,
  },
  {
    statusId: '3',
    statusText: 'In Transit',
    statusCode: 'in_transit',
    isActive: false,
  },
  {
    statusId: '4',
    statusText: 'RTO In Transit',
    statusCode: 'rto_in_transit',
    isActive: false,
  },
  {
    statusId: '5',
    statusText: 'Delivered',
    statusCode: 'delivered',
    isActive: false,
  },
  {
    statusId: '6',
    statusText: 'All Shipments',
    statusCode: 'all',
    isActive: false,
  },
  {
    statusId: '7',
    statusText: 'Failed',
    statusCode: 'failed',
    isActive: false,
  },
  {
    statusId: '8',
    statusText: 'Cancelled',
    statusCode: 'cancelled',
    isActive: false,
  },
];
